// Separated Tabs with content from tabs.js which is used in Menus
const SELECTORS = {
  liItem: ".uo-tab-item",
  tab: ".js-tab", // button
  tabpanel: ".js-tabpanel",
  tabsWrapper: ".uo-tabs-wrapper",
  tabsContainer: ".uo-tabs-container",
  button: ".uo-tabs-scroll-btn",
};

const CLASSES = {
  hidden: "hidden",
  activetab: "active",
  focustab: "focus",
};

class UOTabs {
  constructor(context) {
    this.reducedMotionActive = false;
    this.context = context;
    this.tabs = null;
    this.tabsWrapper = null;
    this.tabsContainer = null;
    this.leftScrollBtn = null;
    this.rightScrollBtn = null;
    this.liItems = [];
    this.selectedTab = null;
    this.focusedTabIdx = null;
    this.tablist = null; // element with this role
  }

  init() {
    const tlist = [...this.context.querySelectorAll('[role="tablist"]')];
    this.tablist = tlist[0];
    this.tabs = [...this.context.querySelectorAll(SELECTORS.tab)];
    this.tabpanels = [...this.context.querySelectorAll(SELECTORS.tabpanel)];
    this.tabsWrapper = [
      ...this.context.querySelectorAll(SELECTORS.tabsWrapper),
    ];
    this.tabsWrapper = this.tabsWrapper[0];
    this.tabsContainer = [
      ...this.context.querySelectorAll(SELECTORS.tabsContainer),
    ];
    this.tabsContainer = this.tabsContainer[0];
    const buttons = [...this.context.querySelectorAll(SELECTORS.button)];
    this.leftScrollBtn = buttons[0];
    this.rightScrollBtn = buttons[1];
    this.liItems = Array.from([
      ...this.context.querySelectorAll(SELECTORS.liItem),
    ]);
    if (this.liItems.length === 0) {
      return;
    }
    this.selectedTab = this.tabs[0];
    this.focusedTabIdx = this.getTabIdx(this.selectedTab);
    this.showNavigation();
    this.subscribe();
  }

  showNavigation() {
    const liItemsLength = this.liItems.length;
    const lastTabCoordinates =
      this.liItems[liItemsLength - 1].getBoundingClientRect();
    const containerCoordinates = this.tabsContainer.getBoundingClientRect();
    let liElementMargin = "60px";

    if (lastTabCoordinates.right <= containerCoordinates.right) {
      this.leftScrollBtn.classList.add("hidden");
      this.rightScrollBtn.classList.add("hidden");
      this.tabsWrapper.style.width = "min-content";
      liElementMargin = "0";
    }
    if (liItemsLength > 0) {
      this.liItems[0].style.marginLeft = liElementMargin;
      this.liItems[liItemsLength - 1].style.marginRight = liElementMargin;
    }
  }

  subscribe() {
    const reducedMotionQuery = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    );

    reducedMotionQuery.addListener(() => {
      this.reducedMotionActive = reducedMotionQuery.matches;
    });
    this.reducedMotionActive = reducedMotionQuery.matches;

    this.tabs.forEach((tab) => {
      tab.addEventListener("click", (event) => {
        const currentTab = event.currentTarget;
        const isNotActiveTab = !currentTab.classList.contains(
          CLASSES.activetab
        );
        if (!isNotActiveTab) {
          return;
        }
        event.preventDefault();
        this.scrollTabIntoView(currentTab);

        //delay toggleTab only if left/right buttons are present
        if (this.liItems[0].style.marginLeft == "0px") {
          this.toggleTab(currentTab);
        } else {
          setTimeout(() => {
            this.toggleTab(currentTab);
          }, 400);
        }
      });
    });

    this.leftScrollBtn.addEventListener("click", () => {
      this.scrollToTab("left");
    });

    this.rightScrollBtn.addEventListener("click", () => {
      this.scrollToTab("right");
    });

    // implement keyboard navigation
    this.tablist.addEventListener("keydown", (event) => {
      event.preventDefault();
      if (event.key === "ArrowRight") {
        this.focusedTabIdx += 1;
        if (this.focusedTabIdx >= this.tabs.length) {
          this.focusedTabIdx = this.tabs.length - 1;
        }
        this.moveFocus();
      } else if (event.key === "ArrowLeft") {
        this.focusedTabIdx -= 1;
        if (this.focusedTabIdx < 0) {
          this.focusedTabIdx = 0;
        }
        this.moveFocus();
      } else if (event.key === "Home") {
        event.preventDefault();
        this.focusedTabIdx = 0;
        this.moveFocus();
      } else if (event.key === "End") {
        event.preventDefault();
        this.focusedTabIdx = this.tabs.length - 1;
        this.moveFocus();
      } else if (event.key === "Enter" || event.key === " ") {
        this.tabs[this.focusedTabIdx].click();
      }
    });
  }

  toggleTab(tab) {
    this.makeAllTabsInactive()
      .hideAllTabpanels()
      .makeTabActive(tab)
      .showTabpanel(tab)
      .hideFocus();
    this.selectedTab = tab;
    this.focusedTabIdx = this.getTabIdx(this.selectedTab);
    return this;
  }

  moveFocus() {
    this.tabs.forEach((tab, idx) => {
      if (this.focusedTabIdx === idx) {
        this.scrollTabIntoView(this.tabs[this.focusedTabIdx]);
        tab.classList.add(CLASSES.focustab);
      } else {
        tab.classList.remove(CLASSES.focustab);
      }
    });
  }

  hideFocus() {
    this.tabs.forEach((tab) => {
      tab.classList.remove(CLASSES.focustab);
    });
  }

  makeAllTabsInactive() {
    this.tabs.forEach((tab) => {
      tab.classList.remove(CLASSES.activetab);
      tab.setAttribute("aria-selected", "false");
      tab.setAttribute("tabindex", "-1");
    });
    return this;
  }

  hideAllTabpanels() {
    this.tabpanels.forEach((tabpanel) => {
      tabpanel.classList.add(CLASSES.hidden);
    });
    return this;
  }

  makeTabActive(tab) {
    //current tab
    let offsetLeftOld = this.selectedTab.offsetLeft;
    const offsetWidthOld = this.selectedTab.offsetWidth;

    //list container
    let ulContainer = document.querySelector(".uo-tabs");
    let scrollLeft = ulContainer.scrollLeft;
    offsetLeftOld = offsetLeftOld - scrollLeft;

    //add tab indicator for animation
    const tabIndicator = document.createElement("li");
    tabIndicator.classList.add("uo-tab-indicator");
    tabIndicator.style.left = "0";
    tabIndicator.style.transform = `translateX(${offsetLeftOld}px)`;
    tabIndicator.style.width = `${offsetWidthOld}px`;
    tabIndicator.style.transition = this.reducedMotionActive
      ? "none"
      : "transform 0.3s ease, width 0.3s ease";
    ulContainer.appendChild(tabIndicator);

    //new tab
    const offsetLeftNew = tab.offsetLeft - scrollLeft;
    const offsetWidthNew = tab.offsetWidth;

    // trigger reflow to apply initial styles before animating
    tabIndicator.getBoundingClientRect(); // force reflow

    //animate selection
    tabIndicator.style.width = `${offsetWidthNew}px`;
    tabIndicator.style.transform = `translateX(${offsetLeftNew}px)`;

    // Remove tab indicator, after animation
    tabIndicator.addEventListener(
      "transitionend",
      (e) => {
        if (e.propertyName === "transform") {
          tabIndicator.remove();
          tab.classList.add(CLASSES.activetab);
          tab.setAttribute("aria-selected", "true");
          tab.setAttribute("tabindex", "0");
        }
      },
      { once: true }
    );
    return this;
  }

  showTabpanel(element) {
    const tabUid = element.dataset.tab;
    this.getAssociatedTabpanel(tabUid).classList.remove(CLASSES.hidden);
    return this;
  }

  getAssociatedTabpanel(tabUid) {
    const tabpanel = this.tabpanels.filter(
      (tabpanel) => tabpanel.dataset.tab === tabUid
    );
    if (tabpanel.length > 0) {
      return tabpanel[0];
    }
    return null;
  }

  scrollToTab(direction) {
    let targetTab;
    const firstTab = this.liItems[0];
    const lastTab = this.liItems[this.liItems.length - 1];
    const visibleTabs = this.liItems.filter((tab) => {
      const rect = tab.getBoundingClientRect();
      const containerRect = this.tabsContainer.getBoundingClientRect();
      return (
        Math.floor(rect.left) >= Math.floor(containerRect.left) &&
        Math.floor(rect.right) <= Math.floor(containerRect.right)
      );
    });

    if (!visibleTabs.length) {
      if (direction === "left") {
        targetTab = firstTab;
      } else {
        targetTab = lastTab;
      }
      this.scrollTabIntoView(targetTab);
      return;
    }

    if (visibleTabs.length > 0) {
      if (direction === "left") {
        targetTab = visibleTabs[0].previousElementSibling;
      } else {
        targetTab = visibleTabs[visibleTabs.length - 1].nextElementSibling;
      }
      if (targetTab) {
        this.scrollTabIntoView(targetTab);
      }
    }
  }

  scrollTabIntoView(tab) {
    tab.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "center",
    });
  }

  getTabPosition(tab) {
    const tabRect = tab.getBoundingClientRect();
    return { x: Math.floor(tabRect.x), y: Math.floor(tabRect.width) };
  }

  getTabIdx(tab) {
    let index = null;
    this.tabs.forEach((element, idx) => {
      if (element.id === tab.id) {
        index = idx;
      }
    });
    return index;
  }
}

export { UOTabs };
